import { i18n } from '@zet/localization'

const Filters = [
  {
    icon: '',
    text: i18n.t('earnings.all'),
    key: 'all',
  },
  {
    icon: 'DoneOutlined',
    text: i18n.t('earnings.paid'),
    key: 'paid',
  },
  {
    icon: 'CautionOutlined',
    text: i18n.t('earnings.pending'),
    key: 'pending',
  },
  {
    icon: 'CircleCloseOutlined',
    text: i18n.t('earnings.failed'),
    key: 'failed',
  },
]

export { Filters }
